import { createContext, useContext, useState, useCallback, useEffect } from 'react';
import { useAuth } from './AuthContext';
import { api } from '../lib/api';

const Ctx = createContext(null);

export function MarketingAddonProvider({ children }) {
  const { token } = useAuth();
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(false);

  const refresh = useCallback(async () => {
    if (!token) return;
    setLoading(true);
    try {
      const r = await api.marketingAddonStatus(token);
      setStatus(r?.addon || null);
    } catch { setStatus(null); }
    finally { setLoading(false); }
  }, [token]);

  useEffect(() => { refresh(); }, [refresh]);

  const activated = status?.activated === true;
  const remaining = status?.remaining ?? 0;
  const quota = (status?.monthly_quota ?? 0) + (status?.purchased_extra_credits ?? 0);
  const used = status?.designs_used_this_month ?? 0;

  return (
    <Ctx.Provider value={{ status, activated, remaining, quota, used, loading, refresh }}>
      {children}
    </Ctx.Provider>
  );
}

export function useMarketingAddon() {
  const ctx = useContext(Ctx);
  if (!ctx) throw new Error('useMarketingAddon must be inside MarketingAddonProvider');
  return ctx;
}
